import axios from "axios";
import { API_BASE_URL, SUBSCRIPTION_ENDPOINTS } from "../constants/apis";
import tokenRefreshService from "./tokenRefresh";

// Get subscription plans from API
export const getSubscriptionPlans = async () => {
    try {
        // Try without authentication first (for public pricing display)
        const response = await axios.get(`${API_BASE_URL}${SUBSCRIPTION_ENDPOINTS.SUBSCRIPTION_CRUD}`);
        return response.data;
    } catch (error) {
        console.error('Error getting subscription plans:', error);
        // If public access fails, try with authentication
        try {
            const token = await tokenRefreshService.getValidToken();
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            const response = await axios.get(`${API_BASE_URL}${SUBSCRIPTION_ENDPOINTS.SUBSCRIPTION_CRUD}`, { headers });
            return response.data;
        } catch (authError) {
            console.error('Error getting subscription plans with auth:', authError);
            throw authError;
        }
    }
}